module.exports = __webpack_public_path__ + "static/media/paris.888aba5c.jpg";